import { OTHER_OPTION } from './ContentSuggestionReasonInputs.constants';

export function getRejectedSelectValue(reason) {
  if (reason.startsWith(OTHER_OPTION)) {
    return OTHER_OPTION;
  }

  return reason;
}

export function getRawReasonValue(reason, rejected) {
  if (rejected && reason.startsWith(OTHER_OPTION)) {
    if (reason === OTHER_OPTION) {
      return '';
    }

    return reason.replace(`${OTHER_OPTION}: `, '');
  }

  return reason;
}

export function getRawReasonPlaceholder(reviewed, approved, rejected) {
  if (rejected) {
    return 'Please specify';
  }

  if (reviewed) {
    return `Reason for ${approved ? 'approval' : 'rejection'}`;
  }

  return 'Reason for approval or rejection';
}
